import { Params, useParams } from "react-router-dom";

export const useDynamicParams = (paramsFromMatch?: Params<string>) => {
    const routeParams = useParams();
    const params = paramsFromMatch || routeParams;

    const paramKeys = ["reservationTypeId", "grouppoollid", "poollid", "unitlid", "id"];

    const parsedParams = paramKeys.reduce((acc, key) => {
        // Get the id.
        const id = params[key]?.split("-").pop();
        acc[key] = id ? parseInt(id) : undefined;
        return acc;
    }, {} as Record<string, number | undefined>);

    const { reservationTypeId, grouppoollid, poollid, unitlid, id } = parsedParams;

    return { reservationTypeId, grouppoollid, poollid, unitlid, id };
};
